<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="searchBox">
        <div class="search-item">
          <p>用户ID：</p>
          <input type="text" placeholder="请输入用户ID" v-model="obj.uid">
        </div>
        <div class="search-item">
          <p>用户昵称：</p>
          <input type="text" placeholder="请输入用户昵称" v-model="obj.name">
        </div>
        <div class="btnBox">
          <button class="btn btn-search" @click="searchSub">搜索</button>
          <button class="btn btn-reset" @click="resetSub">重置</button>
        </div>
      </div>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>列表</p>
          <div class="btnBox">
            <!-- <button class="btn btn-add" @click="addShow">添加banner</button> -->
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.uid">{{item.uid}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.problem_type==1?'功能异常':item.problem_type==2?'体验问题':item.problem_type==3?'题目问题':item.problem_type==4?'付费问题':item.problem_type==5?'新功能建议':'其他'">
                {{item.problem_type==1?'功能异常':item.problem_type==2?'体验问题':item.problem_type==3?'题目问题':item.problem_type==4?'付费问题':item.problem_type==5?'新功能建议':'其他'}}
              </p>
              <p :title="item.problem_content">{{item.problem_content}}</p>
              <p :title="item.first_image">
                <!-- <img :src="'https://pic.bi-rong.com/'+item.first_image" alt=""> -->
                <img :src="item.first_image" alt="">
              </p>
              <p :title="item.add_time">{{item.add_time}}</p>
              <p title="详情" style="color:#FF7543;">
                <span @click="lookDetail(item)">详情</span>
              </p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 添加or编辑提示框 -->
    <div class="msgBox tipsBox" v-if="showType">
      <div class="contv">
        <p class="title">查看详情</p>
        <form style="text-align: left">
          <div class="write-txt">
            <p>问题类型：</p>
            <div class="tips-txt">{{addObj.problem_type==1?'功能异常':addObj.problem_type==2?'体验问题':addObj.problem_type==3?'题目问题':addObj.problem_type==4?'付费问题':addObj.problem_type==5?'新功能建议':'其他'}}</div>
          </div>
          
          <div class="write-txt">
            <p>内容：</p>
            <div class="tips-txt">{{addObj.problem_content}}</div>
          </div>

          <div class="write-txt">
            <p>图片：</p>
            <img :src="item" alt="" v-for="(item,index) in addObj.problem_images" :key="(index+1)" @click="lookImg(item)">
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>

    <div class="msgBox imgBox" v-if="imgType" @mousewheel="handerPictu($event)">
      <button class="btn btn-hide" @click="imgHide">关闭</button>
      <div class="contv">
        <img :src="imgUrl" class="img" alt="" @mousedown="moveSub($event)">
      </div>
    </div>
  </div>
  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { getBannerList,saveBanner,getUploadToken,saveBannerStatus,delBanner,getEvaluateList } from "@/assets/js/api";
export default {
  name: "exam",
  data() {
    return {
      navId:'7',
      childrenID:'7-2',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'用户ID'},
        {id:3,title:'用户昵称'},
        {id:4,title:'问题类型'},
        {id:5,title:'内容'},
        {id:6,title:'图片'},
        {id:8,title:'提交时间'},
        {id:9,title:'操作'},
      ],
      dataList:[],
      showType:'',
      token:'',
      obj:{
        page:1,
        rows:10,
      },
      addObj:{
        
      },
      totalPage:0,
      userData:{
        authority:[],
      },
      loadTxt:'',
      imgType:false,
      imgUrl:'',
      imgScale : 1,
      x:0,
      y:0
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.userData = this.$refs.navBox.userData
    this.token =this.userData.token;
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    // 取消
    closeSub(){
      this.addObj={};
      this.showType = false;
    },

    // 搜索
    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    // 重置
    resetSub(){
      this.addObj={};
      this.obj = {
        page:1,
        rows:10,
      }
      this.dataList = [];
      this.getList();
      
    },

    getList(){
      var that = this;
      getEvaluateList(this.obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data.list;
          that.totalPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      })
    },

    lookDetail(e){
      this.showType = 'edit';
      this.addObj = e;
    },

    lookImg(e){
      this.imgType = true;
      this.imgUrl = e;
    },

    handerPictu(event){
      var value = event.deltaY;
      var that = this;
      if(value > 0){
          if(that.imgScale <= 0.3){
              return false; 
          }
          that.imgScale = that.imgScale - 0.1;
      } else {
          if(that.imgScale >= 10){
              return false;
          }
          that.imgScale = that.imgScale + 0.1;
      };
      $('.imgBox img').css('transform','scale('+that.imgScale+')');
    },

    moveSub(e){
      e.preventDefault();
      // 获取元素
      var personBox = document.querySelector(".imgBox");
      var img = document.querySelector(".img");
      var x = e.pageX - img.offsetLeft;
      var y = e.pageY - img.offsetTop;
      // $('.img').addClass('fixed');
      // 添加鼠标移动事件
      personBox.addEventListener("mousemove", move);
      function move(e) {
          $('.img').addClass('fixed');
          img.style.left = e.pageX - x + "px";
          img.style.top = e.pageY - y + "px";
      }
      // 添加鼠标抬起事件，鼠标抬起，将事件移除
      img.addEventListener("mouseup", function () {
          personBox.removeEventListener("mousemove", move);
          // $('.img').removeClass('fixed');
      });
      // 鼠标离开父级元素，把事件移除
      personBox.addEventListener("mouseout", function () {
          personBox.removeEventListener("mousemove", move);
      });
    },
   

    imgHide(){
      this.imgType = false;
      this.imgScale = 1;
      $('.img').css('top','50%');
      $('.img').css('left','50%');
      $('.img').removeClass('fixed');
    }
  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: calc( 100% / 8 );
}

.dataList .listItem p img{
  width: 100%;
}

.ss{
  height: 36px;
    line-height: 36px;
    font-size: 15px;
    color: #3D3D3D;
    width: 225px;
    background-color: #F4F5F8;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
    display: inline-block;
    vertical-align: top;
    padding: 10px 20px;
}

.el-switch,
.el-radio-group{
  height: 36px;
  width: 225px;
}

.el-radio{
  line-height: 36px;
}

.el-radio__label{
  font-size: 15px;
}

.write-txt .upload{
  display: inline-block;
  width: 225px;
  vertical-align: top;
}
.tipsBox form .write-txt p{
  width: 200px;
}
.write-txt .upload .img img{
  width: 100%;
}
.tipsBox .contv{
  height: 80%;
  overflow-y: auto;
  overflow-x: hidden;
}

.write-txt img{
  width: 100px;
  vertical-align: top;
  display: inline-block;
  margin-right: 10px;
}

.imgBox .contv{
  width: 80%;
  height: 80%;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}
.imgBox img.fixed{
  position: fixed;
  /* top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  transform-origin:center; */
}
.btn-hide{
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #fff;
  border-radius: 5px;
  border: none;
  font-size: 14px;
  color: #3D3D3D;
  padding: 10px 15px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/market/feedback.vue